import Model, { ID } from 'src/models/Model'
import MarketingSubscription from 'src/models/subscription/MarketingSubscription'

export default class UserMarketingSubscription extends Model {
  static name = 'UserMarketingSubscription'

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      marketingSubscription: {
        type: MarketingSubscription,
        reference: true,
        output: true
      },
      allowEmail: {
        type: Boolean,
        default: true
      },
      allowPush: {
        type: Boolean,
        default: false
      },
      allowSms: {
        type: Boolean,
        default: false
      }
    }
  }
}
